import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable({ providedIn: 'root' })
export class HealthService {

    private api_url = `${environment.ApiUrl}/health`;

    constructor(private http: HttpClient) { }

    healthCheck(){
        const url = `${this.api_url}/healthCheck`;
        return this.http.get<boolean>(url, httpOptions);
    }
}